import Swiper from 'swiper';
import { hasClass, addClass, removeClass } from '../helpers/helpers';
import { isMobileOrTablet } from '../helpers/layout';

// Swiper materials driver slider
const init = function(swiperTarget) {
  const swiperMaterialsWrapper = document.querySelector(
    '.js-swiper-materials-wrapper'
  );
  const swiperSlides = document.querySelectorAll('.swiper-materials__slide');
  const swiperSlideNodes = Array.prototype.slice.call(swiperSlides);
  const materialSlider = document.querySelector(swiperTarget);
  const resizeSlideWidth = function(breakpoint) {
    const options = {
      max: 4.5,
      '991': 3.5,
    };
    return options[breakpoint] || 1.5;
  };
  const windowWidth = window.innerWidth;
  const windowOrientation = window.orientation;
  const resetScrollPosition = function() {
    const swiperOffsetTop = swiperMaterialsWrapper.offsetTop;
    document.documentElement.scrollTop = document.body.scrollTop = swiperOffsetTop;
    // remove lock scroll scroll position for mobile modal panel
    if (isMobileOrTablet()) {
      removeClass(document.body, 'overflow-hidden');
    }
    return swiperOffsetTop;
  };
  const resetPanel = function(materialSlider, swiper) {
    removeClass(swiperMaterialsWrapper, 'has-opened-modal');
    removeClass(materialSlider, 'has-opened-panel');
    // make slides default width
    swiper.params.slidesPerView = resizeSlideWidth(swiper.currentBreakpoint);
  };
  const openPanel = function(e, swiper, materialSlider) {
    if (hasClass(e.target, 'js-swiper-material-expand')) {
      // get the index of the index of the clicked slide
      const clickedIndex = swiperSlideNodes.indexOf(
        e.target.parentNode.parentNode.parentNode
      );
      if (hasClass(materialSlider, 'has-opened-panel')) {
        resetScrollPosition();
        resetPanel(materialSlider, swiper);
      } else {
        addClass(swiperMaterialsWrapper, 'has-opened-modal');
        addClass(materialSlider, 'has-opened-panel');
        // lock scroll scroll position for mobile modal panel
        document.documentElement.scrollTop = document.body.scrollTop = resetScrollPosition();
        if (isMobileOrTablet()) {
          addClass(document.body, 'overflow-hidden');
        }
        // make slides 100% width
        swiper.params.slidesPerView = 1;
        // change active index to the index of the clicked slide
        swiper.activeIndex = clickedIndex;
      }
      e.preventDefault();
      e.stopPropagation();
    } else if (hasClass(e.target, 'js-swiper-material-close')) {
      resetScrollPosition();
      resetPanel(materialSlider, swiper);
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const materialsSwiper = new Swiper(swiperTarget, {
    slidesPerView: 4.5,
    loop: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    observer: true,
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    simulateTouch: false,
    on: {
      init: function() {
        const swiper = this;
        materialSlider.addEventListener(
          'click',
          function(e) {
            openPanel(e, swiper, materialSlider);
          },
          false
        );
      },
      resize: function() {
        if (
          window.innerWidth !== windowWidth ||
          window.orientation !== windowOrientation
        ) {
          resetPanel(materialSlider, this);
        }
      },
    },
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: '.js-swiper-materials-button-next',
      prevEl: '.js-swiper-materials-button-prev',
    },
    breakpoints: {
      991: {
        slidesPerView: 3.5,
      },
      479: {
        slidesPerView: 1.5,
      },
    },
  });
};

export default {
  init,
};
